const IPQS_FINGERPRINT_KEY = `${window.app.env}_dfp`;

// Create IPQ configuration
window.IPQ = {
    Callback: function () {
        // Staff impersonating a borrower must not become the borrower's device.
        if (window.is_impersonating) {
            return;
        }

        // Store user and loan information
        const user = JSON.parse(window.user);
        if (!user) {
            return;
        }
        Startup.Store('userID', user.id);

        // Function to send data to /dfp endpoint
        const sendToDfp = (data, isEncrypted = false) => {
            // Prepare the payload with the appropriate property
            const payload = isEncrypted 
                ? { encrypted_data: data } 
                : { raw_data: data };
                
            return fetch('/dfp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Server response was not OK');
                }
                return response.json();
            });
        };

        // Check if we already have encrypted fingerprint data
        const storedFingerprint = localStorage.getItem(IPQS_FINGERPRINT_KEY);
        
        if (storedFingerprint) {
            // Use the encrypted data from localStorage
            console.log('Using stored fingerprint data');
            
            // Send the stored encrypted data to the server
            sendToDfp(storedFingerprint, true)
            .catch(error => {
                console.error('Failed to process stored fingerprint data:', error);
                // In case of failure with stored data, clear it and try to get fresh data
                localStorage.removeItem(IPQS_FINGERPRINT_KEY);
            });
            
            return;
        }
        
        // If no data in localStorage, get new fingerprint data
        Startup.AfterResult(function (result) {
            // Send fingerprint data to server for encryption
            sendToDfp(result, false)
            .then(data => {
                // Store encrypted fingerprint data from server response in localStorage
                localStorage.setItem(IPQS_FINGERPRINT_KEY, JSON.stringify(data));
            })
            .catch(error => {
                console.error('Failed to process fingerprint data:', error);
                // In case of failure, don't store potentially compromised data
                // and clear any existing data to prevent using tampered information
                localStorage.removeItem(IPQS_FINGERPRINT_KEY);
            });
        });
        
        Startup.Init();
    }
}; 